/**
 * 奖励金状态 枚举  01  待审核  02 已审核
 */
export enum BountyStatusEnums {
  WAIT_CHECK = "01",
  CHECKED = "02"
}
/**
 * 积分状态 枚举  0  待审核  1 已审核
 */
export enum IntegralStatusEnums {
  WAIT_CHECK = 0,
  CHECKED = 1
}
/**
 * 星级成长值，奖励金，积分明细页面筛选，0 售出历史  1 按日月查看  2 打开筛选
 */
export enum GrowthFilterEnums {
  SALE_HISTORY = 0,
  DAY_MONTH = 1,
  FILTER = 2
}
